import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../../../icon/icon.component';

@Component({
    selector: 'nw-side-menu-breadcrumb',
    templateUrl: './side-menu-breadcrumb.component.html',
    styleUrls: ['./side-menu-breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent]
})
export class SideMenuBreadcrumbComponent {
    @Input() label!: string;
}
